import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import moment from "moment";
import { requisitarNovaEspera } from "../prontuario-nova-espera";
import { buscarOpcoesAgendaSessoes } from '@/utils/agendaSessoesBusca';

const state = {
    dataAgendamento: "",
    medicoAgendamento: {},
    horarioAgendamentoAlterando: {},
    pacienteAgendamentoAlterando: {},
    localizacaoFisica: window.localStorage.getItem("localizacaoFisicaAgenda"),
    horarioAgendamentoAtender: {}, 
    telefoneBuscadoTelefonia: "", 
    senhasTotemPendente: [], 
    filasSenhasTotemPendente: []
};

const getters = {
    dataAgendamento(state) {
        return state.dataAgendamento;
    },
    medicoAgendamento(state) {
        return state.medicoAgendamento;
    },
    horarioAgendamentoAlterando(state) {
        return state.horarioAgendamentoAlterando;
    },
    pacienteAgendamentoAlterando(state) {
        return state.pacienteAgendamentoAlterando;
    },
    localizacaoFisica(state) {
        return state.localizacaoFisica;
    },
    horarioAgendamentoAtender(state) {
        return state.horarioAgendamentoAtender;
    },
    telefoneBuscadoTelefonia(state) {
        return state.telefoneBuscadoTelefonia;
    },
    senhasTotemPendente(state) {
        return state.senhasTotemPendente;
    }, 
    filasSenhasTotemPendente(state) {
        return state.filasSenhasTotemPendente;
    }, 
    filtraSenhasTotemPendente(state) {
        const filasMarcadas = state.filasSenhasTotemPendente.filter(f => f.marcado === "1").map(f => f.nome);
        if(filasMarcadas.length > 0) {
            return state.senhasTotemPendente.filter(s => filasMarcadas.includes(s.SENHA.replace(/\d/g, "")));
        } else {
            return state.senhasTotemPendente;
        }
    }
};

const mutations = {
    updateDataAgendamento(store, dataAgendamento) {
        store.dataAgendamento = dataAgendamento;
    },
    updateMedicoAgendamento(store, medicoAgendamento) {
        store.medicoAgendamento = medicoAgendamento;
    },
    updateHorarioAgendamentoAlterando(store, horarioAgendamentoAlterando) {
        store.horarioAgendamentoAlterando = horarioAgendamentoAlterando;
    },
    updatePacienteAgendamentoAlterando(store, pacienteAgendamentoAlterando) {
        store.pacienteAgendamentoAlterando = pacienteAgendamentoAlterando;
    },
    updateLocalizacaoFisica(store, localizacaoFisica) {
        window.localStorage.setItem("localizacaoFisicaAgenda", localizacaoFisica);
        store.localizacaoFisica = localizacaoFisica;
    },
    updateHorarioAgendamentoAtender(store, horarioAgendamentoAtender) {
        store.horarioAgendamentoAtender = horarioAgendamentoAtender;
    },
    updateTelefoneBuscadoTelefonia(store, telefoneBuscadoTelefonia) {
        store.telefoneBuscadoTelefonia = telefoneBuscadoTelefonia;
    }, 
    updateSenhasTotemPendente(store, senhasTotemPendente) {
        senhasTotemPendente.forEach((senhaTotemPendenteItem) => {
            let indice = -1;

            store.senhasTotemPendente.forEach((senhaTotemPendente, index) => {
                if(senhaTotemPendente.ID_TOTEM_SENHA == senhaTotemPendenteItem.ID_TOTEM_SENHA) {
                    indice = index;
                }
            });
            
            if(indice == -1) {
                store.senhasTotemPendente.push(senhaTotemPendenteItem);
            }
        });

        for(let index = store.senhasTotemPendente.length - 1; index >= 0; index--) {
            let indice = -1;

            senhasTotemPendente.forEach((senhaTotemPendenteItem, index2) => {
                if(store.senhasTotemPendente[index].ID_TOTEM_SENHA == senhaTotemPendenteItem.ID_TOTEM_SENHA) {
                    indice = index2;
                }
            });
            
            if(indice == -1) {
                store.senhasTotemPendente.splice(index, 1);
            }
        }

        const filas = store.senhasTotemPendente.map(s => s.SENHA.replace(/\d/g, "")).filter((value, index, self) => self.indexOf(value) === index);

        filas.forEach(fila => {
            if(!store.filasSenhasTotemPendente.find(f => f.nome === fila)) {
                store.filasSenhasTotemPendente.push({
                    nome: fila, 
                    marcado: "1"
                });
            }
        });

        store.filasSenhasTotemPendente = store.filasSenhasTotemPendente.filter(f => filas.includes(f.nome));
    }, 
    updateSenhaChamando(store, dados) {
        const index = store.senhasTotemPendente.findIndex(senha => senha.ID_TOTEM_SENHA === dados.ID_TOTEM_SENHA);

        if (index !== -1) {
            store.senhasTotemPendente[index].CHAMADA_POR = dados.USUARIO;
            store.senhasTotemPendente[index].CHAMADA_DATA = moment().format("YYYY-MM-DD HH:mm:ss");
            store.senhasTotemPendente[index].CHAMADA_LOCALIZACAO_FISICA = dados.LOCALIZACAO_FISICA;
        }
    }, 
    updateSenhaDescartando(store, idTotemSenha) {
        const index = store.senhasTotemPendente.findIndex(senha => senha.ID_TOTEM_SENHA === idTotemSenha);

        if (index !== -1) {
            store.senhasTotemPendente[index].descartando = true;
        }
    }, 
    updateFilaSelecionada(store, filaNome) {
        store.filasSenhasTotemPendente.forEach(fila => {
            if(fila.nome === filaNome) {
                fila.marcado = fila.marcado === "1" ? "0" : "1";
            }
        });
    }, 
    updateSenhaConsumir(store, idTotemSenha) {
        const index = store.senhasTotemPendente.findIndex(senha => senha.ID_TOTEM_SENHA === idTotemSenha);

        if (index !== -1) {
            store.senhasTotemPendente.splice(index, 1);
            const filas = store.senhasTotemPendente.map(s => s.SENHA.replace(/\d/g, "")).filter((value, index, self) => self.indexOf(value) === index);

            store.filasSenhasTotemPendente = store.filasSenhasTotemPendente.filter(f => filas.includes(f.nome));
        }
    }
};

const actions = {
    getOpcoesAgendaSessoesBox(context, filtros) {
        return buscarOpcoesAgendaSessoes(filtros);
    },
    getMapaAgenda(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/mapa", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAgendamentosHojePaciente(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/agendamentosHojePaciente", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAgendamentosHojePacienteComChegada(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/agendamentosHojePacienteComChegada", { ID_PACIENTE: idPaciente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getAgendamento(context, dados) {
        if(dados.CONFERIR_PROCEDIMENTOS) {
            if(!JwtService.getToken()) return Promise.reject(new Error("Sessão expirada."));
            ApiService.setHeader();
            return ApiService.postOnce("agendamentos/access/obterAgendamento", dados, { timeout: 120000 }).then(({data}) => {
                if(data?.PROCEDIMENTOS_CONFERIDOS !== true) throw new Error("Não foi possível conferir os procedimentos.");
                return data;
            });
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/obterAgendamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getAgendamentos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("chatlogos/access/buscarAgendamentos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    informarChegada(context, idAgenda) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/informarChegada", { ID_AGENDA: idAgenda }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    informarChegadaComSelecionados(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/informarChegadaComSelecionados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    informarChegadaTotem(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/informarChegadaTotem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    informarChegadaSemPendente(context, idAgenda) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/informarChegada", { ID_AGENDA: idAgenda, SEM_PENDENTE: true }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async listarHorariosDisponiveis(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar os dados do atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/listarHorariosDisponiveis", dados, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida ao consultar os dados do atendimento."); }
        return data;
    },
    listarHorariosPeriodoDisponiveis(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarHorariosPeriodoDisponiveis", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarHorariosAgendados(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarHorariosAgendados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async listarProcedimentos(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/listarProcedimentos", dados, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Lista de procedimentos/classificações inválida."); }
        return data;
    },
    listarProcedimentosPacoteConsulta(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarProcedimentosPacoteConsulta", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarProcedimentosAgendados(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarProcedimentosAgendados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    buscarKitsDosProcedimentosAgendados(context, idAgenda) {
        if (!JwtService.getToken()) return Promise.reject(new Error("Sessão expirada. Entre novamente para faturar."));
        ApiService.setHeader();
        return ApiService.post("agendamentos/access/listarKitsDosProcedimentosAgendados", {ID_AGENDA: idAgenda}).then(({ data }) => data);
    },
    async getOrcamentosDisponiveisAgenda(context, dados) {
        if (!JwtService.getToken()) throw new Error('Sessão expirada');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('agendamentos/access/orcamentosDisponiveis', dados);
        if (!Array.isArray(data)) throw new Error(data?.ERRO || 'Não foi possível consultar os orçamentos do paciente.');
        return data;
    },
    incluirAgendamento(context, dados) {
        if (dados.CONFIRMAR_PROCEDIMENTOS || dados.CONFERIR_SESSAO_ORCAMENTO || dados.procedimentos?.some(p => p.ID_PACIENTE_ORCAMENTO)) {
            if (!JwtService.getToken()) return Promise.resolve({ ERRO: 'Sessão expirada' });
            ApiService.setHeader();
            return ApiService.postOnce('agendamentos/access/incluirAgendamento', dados, { timeout: 120000 })
                .then(({ data }) => data)
                .catch(() => ({ ERRO: 'Não foi possível confirmar a gravação. Confira a agenda antes de tentar novamente.' }));
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/incluirAgendamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async consultarDisponibilidadeAgendaFlexivel(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/horariosVagosPorMedico", dados, { timeout: 30000 });
        if (!Array.isArray(data)) throw new Error("Resposta de disponibilidade inválida");
        return data;
    },
    horariosDiposniveisMedico(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/horariosVagosPorMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    atualizarDataAgendamento({ commit }, dataAgendamento) {
        commit('updateDataAgendamento', dataAgendamento);
    },
    atualizarMedicoAgendamento({ commit }, medicoAgendamento) {
        commit('updateMedicoAgendamento', medicoAgendamento);
    },
    atualizarHorarioAgendamentoAlterando({ commit }, horarioAgendamentoAlterando) {
        commit('updateHorarioAgendamentoAlterando', horarioAgendamentoAlterando);
    },
    atualizarPacienteAgendamentoAlterando({ commit }, pacienteAgendamentoAlterando) {
        commit('updatePacienteAgendamentoAlterando', pacienteAgendamentoAlterando);
    },
    atualizarTelefoneBuscadoTelefonia({ commit }, telefoneBuscadoTelefonia) {
        commit('updateTelefoneBuscadoTelefonia', telefoneBuscadoTelefonia);
    }, 
    atualizarSenhaChamando({ commit }, dados) {
        commit("updateSenhaChamando", dados);
    }, 
    atualizarSenhaDescartando({ commit }, idTotemSenha) {
        commit("updateSenhaDescartando", idTotemSenha);
    },
    listaAgendaAuxilia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listaAgendaAuxilia", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    incluiAgendaAuxiliaInclusao(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/incluiAgendaAuxiliaInclusao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    removeAgendaAuxiliaInclusao(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/removeAgendaAuxiliaInclusao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async liberarReservaAgendaFlexivel(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/removeAgendaAuxiliaInclusao", dados, { timeout: 30000 });
        return data;
    },
    numerosAgendamentosMedico(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/numerosAgendamentosMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async atualizarAgendaStatus(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para atualizar a agenda."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("agendamentos/access/alterarStatus", dados, { timeout: 120000 });
        return data;
    },
    alterarNovaEspera(context, dados) { return requisitarNovaEspera(ApiService, JwtService, dados); },
    async cancelarAgendaAtendimento(context, { dados, consultar = false }) {
        if(!JwtService.getToken()) { throw Object.assign(new Error("Sessão indisponível para cancelar a agenda."), { enviado: false }); }
        ApiService.setHeader();
        const endpoint = consultar ? "consultarCancelamentoAtendimento" : "cancelarAtendimentoConfirmado";
        const { data } = await ApiService.postOnce("agendamentos/access/" + endpoint, dados, { timeout: 120000 });
        return data;
    },
    async concluirAgendaAtendimento(context, { dados, consultar = false, retomar = false }) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para concluir a agenda."); }
        ApiService.setHeader();
        const endpoint = consultar ? "consultarConclusaoAtendimento" : (retomar ? "retomarConclusaoAtendimento" : "concluirAtendimentoConfirmado");
        const { data } = await ApiService.postOnce("agendamentos/access/" + endpoint, dados, { timeout: 120000 });
        return data;
    },
    excluirBloqueioHorario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/excluirBloqueioHorario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    incluirBloqueioHorario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/incluirBloqueioHorario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    pegarAgendamentoParaUsuario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/pegarAgendamentoParaUsuario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarProcedimentosPacienteDoDia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarProcedimentosPacienteDoDia", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    chamarNaTV(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/chamarNaTV", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    excluirAgendamento(context, idAgenda) {
        if (!JwtService.getToken()) return Promise.reject(new Error("Sessão expirada."));
        ApiService.setHeader();
        return ApiService.postOnce("agendamentos/access/excluir", {ID_AGENDA: idAgenda}, { timeout: 120000 }).then(({ data }) => data);
    },
    atualizarLocalizacaoFisica({ commit }, localizacaoFisica) {
        commit('updateLocalizacaoFisica', localizacaoFisica);
    }, 
    incluirFaturamento(context, dados) {
        if (!JwtService.getToken()) return Promise.reject(new Error("Sessão expirada. Entre novamente para faturar."));
        ApiService.setHeader();
        return ApiService.post("agendamentos/access/incluirFaturamento", dados).then(({ data }) => data);
    },
    atualizarHorarioAgendamentoAtender({ commit }, horarioAgendamentoAtender) {
        commit('updateHorarioAgendamentoAtender', horarioAgendamentoAtender);
    }, 
    getProcedimentoAgenda(context, idAgendaExame) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/obterProcedimentoAgenda", {ID_AGENDA_EXAME: idAgendaExame}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarAgendamentosPaciente(context, idPaciente) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarAgendamentosPaciente", {ID_PACIENTE: idPaciente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    listarAgendamentosAposInclusao(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarAgendamentosAposInclusao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    alterarAgendamentoDiaHora(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/alterarAgendamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoPaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoRetornoPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoPacienteNoMes(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoAtendimentoMesPorPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoPlanoNoMes(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoAtendimentoMesPorPlano", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoPlanoNoDia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoAtendimentoDiaPorPlano", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    verificaQuantidadesAgendaPlano(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/quantidadesAgendaPorPlano", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoMedicoPlanoNoDia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoAtDiaPorPlanoMed", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteRetornoMedicoPlanoProcNoDia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoAtDiaPorPlanoMedProc", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteMedicoPlano(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoPlanoPorMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    permiteProcedimentoMedicoPlano(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/validaPermissaoProcedimentoPorMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    verificaVagasPorPlanoMedico(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/verificaVagasPorPlanoMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvaAgendasMultiplas(context, dados) {
        return new Promise(resolve => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/salvarMultiplas", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    obterObrigatoriedadesProcedim(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/verificaObrigatoriedadesProcedim", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async getAgendamentosPorId(context, dados) {
        if (!JwtService.getToken()) throw new Error('Usuário não autenticado.');
        ApiService.setHeader();
        const { data } = await ApiService.post("agendamentos/access/listarAgendamentosPorId", dados);
        return data;
    }, 
    getItensPorAgendas(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/listarItensPorAgendas", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getLeads(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("leads/access/listarLeadsData", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    alterarAgendamentoUnidadeLocal(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/alterarAgendamentoUnidadeLocal", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    verificarSenhasTotemPendente(context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("agendamentos/access/listarSenhas").then(({ data }) => {
                    context.commit("updateSenhasTotemPendente", data);
                    resolve(data);
                });
            }
        });
    }, 
    chamarSenhaTotemPendente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/chamarSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    descartarSenhaTotemPendente(context, idTotemSenha) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/descartarSenha", {ID_TOTEM_SENHA: idTotemSenha}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    solicitarSenhaTotem(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("agendamentos/access/solicitarSenha", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    selecionarFilaSenhaTotem(context, filaNome) {
        context.commit("updateFilaSelecionada", filaNome);
    }, 
    async "SOCKET_painelSenha" ({ commit }, dados) {
        commit("updateSenhaChamando", dados);
    }, 
    async "SOCKET_painelSenhaDescartando" ({ commit }, idTotemSenha) {
        commit("updateSenhaDescartando", idTotemSenha);
    }, 
    async "SOCKET_painelSenhaConsumir" ({ commit }, idTotemSenha) {
        commit("updateSenhaConsumir", idTotemSenha);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
